/**
 * GENERATED FILE — do not edit by hand.
 * Regenerate with:  npm run build:rookie-class
 *
 * Where each recent rookie was taken in the **NFL** draft, keyed by Sleeper
 * player id.
 *
 * This table exists because Sleeper's player payload carries no draft capital
 * at all — no round, no pick, no draft year — and draft capital is the single
 * most predictive input the dynasty model has about a player with no
 * professional snaps. The join is done offline by `scripts/build-rookie-class.ts`
 * against nflverse's `draft_picks` release (openly licensed; a matter of public
 * record rather than anyone's ranking, so R2 does not apply) and committed, the
 * same way `scoutingNotes.ts` is.
 *
 * Rookies whose names could not be resolved to a Sleeper id with confidence are
 * **absent rather than guessed**: attaching one player's draft capital to
 * another would be considerably worse than having no entry, and the runtime
 * already degrades to age-and-rank-only for anyone missing here.
 *
 * Regenerate after each NFL draft. Most recent class: 2026.
 */

/** `[season, round, pick, ageAtDraft]`. Age is null where nflverse lacks it. */
export type RookieRecord = readonly [number, number, number, number | null];

export const ROOKIE_CLASS_LATEST = 2026;

export const ROOKIE_CLASS: Record<string, RookieRecord> = {
  // ---- 2026 class (80) ----
  "13269": [2026, 1, 1, 22], // Fernando Mendoza QB LVR
  "13287": [2026, 1, 3, 21], // Jeremiyah Love RB ARI
  "13279": [2026, 1, 4, 21], // Carnell Tate WR TEN
  "13281": [2026, 1, 8, 22], // Jordyn Tyson WR NOR
  "13275": [2026, 1, 13, 23], // Ty Simpson QB LAR
  "13330": [2026, 1, 16, 21], // Kenyon Sadiq TE NYJ
  "13294": [2026, 1, 20, 22], // Makai Lemon WR PHI
  "13298": [2026, 1, 24, 21], // KC Concepcion WR CLE
  "13276": [2026, 1, 30, 22], // Omar Cooper Jr. WR NYJ
  "13286": [2026, 1, 32, 22], // Jadarian Price RB SEA
  "13417": [2026, 2, 33, 23], // De'Zhaun Stribling WR SFO
  "13346": [2026, 2, 39, 22], // Denzel Boston WR CLE
  "13274": [2026, 2, 47, 22], // Germie Bernard WR PIT
  "13349": [2026, 2, 54, 23], // Eli Stowers TE PHI
  "13299": [2026, 2, 56, 25], // Nate Boerkircher TE JAX
  "13307": [2026, 2, 59, 23], // Marlin Klein TE HOU
  "13278": [2026, 2, 61, 23], // Max Klare TE LAR
  "13272": [2026, 3, 65, 24], // Carson Beck QB ARI
  "13322": [2026, 3, 69, 23], // Sam Roush TE CHI
  "13301": [2026, 3, 71, 22], // Antonio Williams WR WAS
  "13319": [2026, 3, 73, 23], // Oscar Delp TE NOR
  "13285": [2026, 3, 74, 23], // Malachi Fields WR NYG
  "13296": [2026, 3, 75, 22], // Caleb Douglas WR MIA
  "13289": [2026, 3, 76, 22], // Drew Allar QB PIT
  "13320": [2026, 3, 79, 22], // Zachariah Branch WR ATL
  "13293": [2026, 3, 80, 22], // Ja'Kobi Lane WR BAL
  "13353": [2026, 3, 83, 22], // Chris Brazzell II WR CAR
  "13317": [2026, 3, 84, 22], // Ted Hurst WR TAM
  "13434": [2026, 3, 87, 23], // Will Kacmarek TE MIA
  "13411": [2026, 3, 89, 21], // Zavion Thomas WR CHI
  "13414": [2026, 3, 90, 24], // Kaelon Black RB SFO
  "13311": [2026, 3, 94, 22], // Chris Bell WR MIA
  "13421": [2026, 3, 95, 22], // Eli Raridon TE NWE
  "13380": [2026, 4, 105, 23], // Brenen Thompson WR LAC
  "13345": [2026, 4, 108, 23], // Jonah Coleman RB DEN
  "13303": [2026, 4, 110, 22], // Cade Klubnik QB NYJ
  "13268": [2026, 4, 115, 23], // Elijah Sarratt WR BAL
  "13491": [2026, 4, 121, 24], // Kaden Wetjen WR PIT
  "13305": [2026, 4, 122, 23], // Mike Washington Jr. RB LVR
  "13402": [2026, 4, 125, 24], // Skyler Bell WR BUF
  "13324": [2026, 4, 133, 24], // Matthew Hibner TE BAL
  "13420": [2026, 4, 136, 24], // Bryce Lance WR NOR
  "13477": [2026, 4, 140, 24], // Colbie Young WR CIN
  "13297": [2026, 5, 143, 22], // Reggie Virgil WR ARI
  "13400": [2026, 5, 152, 22], // Justin Joly TE DEN
  "13516": [2026, 5, 159, 23], // Max Bredeson TE MIN
  "13337": [2026, 5, 161, 22], // Emmett Johnson RB KAN
  "13408": [2026, 5, 164, null], // Tanner Koziol TE JAX
  "13288": [2026, 5, 165, 22], // Nicholas Singleton RB TEN
  "13412": [2026, 5, 168, 23], // Kendrick Law WR DET
  "13433": [2026, 5, 169, 24], // Riley Nowakowski TE PIT
  "13435": [2026, 5, 170, 24], // Joe Royer TE CLE
  "13273": [2026, 5, 173, 22], // Josh Cuevas TE BAL
  "13302": [2026, 5, 174, 22], // Adam Randall RB BAL
  "13413": [2026, 5, 176, 23], // Cyrus Allen WR KAN
  "13338": [2026, 5, 177, 22], // Kevin Coleman Jr. WR MIA
  "13335": [2026, 5, 178, 23], // Cole Payton QB PHI
  "13429": [2026, 5, 180, null], // Seydou Traore TE MIA
  "13306": [2026, 6, 182, 23], // Taylen Green QB CLE
  "13308": [2026, 6, 185, 23], // Bauer Sharp TE TAM
  "13405": [2026, 6, 187, 23], // Kaytron Allen RB WAS
  "13533": [2026, 6, 190, null], // Barion Brown WR NOR
  "13394": [2026, 6, 191, 23], // Josh Cameron WR JAX
  "13329": [2026, 6, 195, null], // Malik Benson WR LVR
  "13270": [2026, 6, 197, null], // CJ Daniels WR LAR
  "13347": [2026, 6, 198, 22], // Demond Claiborne RB MIN
  "13313": [2026, 6, 199, null], // Emmanuel Henderson Jr. WR SEA
  "13554": [2026, 6, 203, null], // CJ Williams WR JAX
  "13541": [2026, 6, 204, null], // Lewis Bond WR HOU
  "13582": [2026, 7, 218, null], // Anthony Smith WR DAL
  "13282": [2026, 7, 221, 22], // Jack Endries TE CIN
  "13557": [2026, 7, 223, null], // Athan Kaliakmanis QB WAS
  "13422": [2026, 7, 225, 22], // Jaren Kanak TE TEN
  "13295": [2026, 7, 234, null], // Behren Morton QB NWE
  "13424": [2026, 7, 237, 24], // Seth McGowan RB IND
  "13403": [2026, 7, 245, 22], // Jam Miller RB NWE
  "13580": [2026, 7, 248, 23], // Carsen Ryan TE CLE
  "13404": [2026, 7, 249, null], // Garrett Nussmeier QB KAN
  "13333": [2026, 7, 254, 23], // Deion Burks WR IND
  "13577": [2026, 7, 256, 25], // Dallen Bentley TE DEN

  // ---- 2025 class (86) ----
  "12522": [2025, 1, 1, 23], // Cam Ward QB TEN
  "12530": [2025, 1, 2, 22], // Travis Hunter WR JAX
  "12527": [2025, 1, 6, 21], // Ashton Jeanty RB LVR
  "12526": [2025, 1, 8, 22], // Tetairoa McMillan WR CAR
  "12517": [2025, 1, 10, 21], // Colston Loveland TE CHI
  "12518": [2025, 1, 14, 23], // Tyler Warren TE IND
  "12514": [2025, 1, 19, 22], // Emeka Egbuka WR TAM
  "12507": [2025, 1, 22, 22], // Omarion Hampton RB LAC
  "12501": [2025, 1, 23, 22], // Matthew Golden WR GNB
  "12508": [2025, 1, 25, 22], // Jaxson Dart QB NYG
  "12484": [2025, 2, 34, 22], // Jayden Higgins WR HOU
  "12512": [2025, 2, 36, 21], // Quinshon Judkins RB CLE
  "12529": [2025, 2, 38, 22], // TreVeyon Henderson RB NWE
  "12519": [2025, 2, 39, 21], // Luther Burden WR CHI
  "12545": [2025, 2, 40, 25], // Tyler Shough QB NOR
  "12498": [2025, 2, 42, 21], // Mason Taylor TE NYJ
  "12487": [2025, 2, 46, 22], // Terrance Ferguson TE LAR
  "12521": [2025, 2, 50, 22], // Elijah Arroyo TE SEA
  "12509": [2025, 2, 55, 23], // Tre Harris WR LAC
  "12483": [2025, 2, 58, 22], // Jack Bech WR LVR
  "12489": [2025, 2, 60, 24], // RJ Harvey RB DEN
  "12506": [2025, 3, 67, 21], // Harold Fannin TE CLE
  "12547": [2025, 3, 69, 22], // Kyle Williams WR NWE
  "12535": [2025, 3, 70, 23], // Isaac TeSlaa WR DET
  "12492": [2025, 3, 74, 22], // Pat Bryant WR DEN
  "12536": [2025, 3, 79, 23], // Jaylin Noel WR HOU
  "12504": [2025, 3, 83, 22], // Kaleb Johnson RB PIT
  "12482": [2025, 3, 87, 23], // Savion Williams WR GNB
  "12510": [2025, 3, 92, 22], // Jalen Milroe QB SEA
  "12486": [2025, 3, 94, 24], // Dillon Gabriel QB CLE
  "12496": [2025, 3, 102, 22], // Tai Felton WR MIN
  "12540": [2025, 4, 103, 23], // Chimere Dike WR TEN
  "12490": [2025, 4, 104, 22], // Bhayshul Tuten RB JAX
  "12481": [2025, 4, 105, 23], // Cam Skattebo RB NYG
  "12541": [2025, 4, 108, 22], // Dont'e Thornton WR LVR
  "12539": [2025, 4, 110, 23], // Arian Smith WR NYJ
  "12531": [2025, 4, 114, 21], // Trevor Etienne RB CAR
  "12474": [2025, 4, 116, 24], // Woody Marks RB HOU
  "11569": [2025, 4, 117, 22], // Jarquez Hunter RB LAR
  "12502": [2025, 4, 120, 23], // Gunnar Helm TE TEN
  "12469": [2025, 4, 126, 20], // Dylan Sampson RB CLE
  "12641": [2025, 4, 128, 23], // Jaylin Lane WR WAS
  "12505": [2025, 4, 133, 22], // Jalen Royals WR KAN
  "12499": [2025, 4, 136, 22], // Elic Ayomanor WR TEN
  "12634": [2025, 4, 138, 23], // Jordan Watkins WR SFO
  "12524": [2025, 5, 144, 23], // Shedeur Sanders QB CLE
  "12467": [2025, 5, 147, 21], // Jordan James RB SFO
  "12457": [2025, 5, 149, 21], // Jaydon Blue RB DAL
  "12471": [2025, 5, 151, 22], // DJ Giddens RB IND
  "12670": [2025, 5, 158, 23], // KeAndre Lambert-Smith WR LAC
  "12473": [2025, 5, 163, 22], // Mitchell Evans TE CAR
  "12493": [2025, 5, 165, 22], // Oronde Gadsden II TE LAC
  "12497": [2025, 5, 166, 22], // Tory Horton WR SEA
  "12658": [2025, 5, 173, 24], // Jackson Hawes TE BUF
  "12656": [2025, 5, 175, 23], // Robbie Ouzts TE SEA
  "12495": [2025, 6, 179, 21], // Ollie Gordon RB MIA
  "12494": [2025, 6, 181, 22], // Kyle McCord QB PHI
  "12476": [2025, 6, 184, 22], // Devin Neal RB NOR
  "12511": [2025, 6, 185, 23], // Will Howard QB PIT
  "12516": [2025, 6, 188, 22], // Kalel Mullings RB TEN
  "12470": [2025, 6, 189, 22], // Riley Leonard QB IND
  "12543": [2025, 6, 193, 23], // Tahj Brooks RB CIN
  "12705": [2025, 6, 197, 24], // Graham Mertz QB HOU
  "12700": [2025, 6, 202, 22], // Gavin Bartholomew TE MIN
  "12699": [2025, 6, 203, 23], // LaJohntay Wester WR BAL
  "12523": [2025, 6, 208, 22], // Jimmy Horn WR CAR
  "12690": [2025, 6, 213, null], // Tommy Mellott QB LVR
  "12688": [2025, 6, 215, 24], // Cam Miller QB LVR
  "12715": [2025, 7, 219, 22], // Thomas Fidone TE NYG
  "12462": [2025, 7, 223, 21], // Damien Martinez RB SEA
  "12477": [2025, 7, 227, 24], // Kurtis Rourke QB SFO
  "12455": [2025, 7, 228, 22], // Brashard Smith RB KAN
  "12500": [2025, 7, 231, 22], // Quinn Ewers QB MIA
  "12534": [2025, 7, 233, 23], // Kyle Monangai RB CHI
  "12485": [2025, 7, 235, 23], // Tez Johnson WR TAM
  "12544": [2025, 7, 236, 21], // LeQuint Allen RB JAX
  "12475": [2025, 7, 238, 23], // Ricky White WR SEA
  "12738": [2025, 7, 239, 22], // Phil Mafah RB DAL
  "12721": [2025, 7, 240, 23], // Kaden Prather WR BUF
  "12735": [2025, 7, 241, 24], // Caleb Lohner TE DEN
  "12718": [2025, 7, 242, 22], // Konata Mumpfield WR LAR
  "12732": [2025, 7, 244, 22], // Dominic Lovett WR DET
  "12533": [2025, 7, 245, 24], // Jacory Croskey-Merritt RB WAS
  "12480": [2025, 7, 248, 22], // Moliki Matavao TE NOR
  "12743": [2025, 7, 252, null], // Junior Bergen WR SFO
  "12725": [2025, 7, 255, 24], // Luke Lachey TE HOU
};

/** Look up a player's NFL draft capital, or null if he is not in the table. */
export function rookieRecord(sleeperId: string): RookieRecord | null {
  return ROOKIE_CLASS[sleeperId] ?? null;
}
